import { minWidthQueries } from '@operations/utils/useMediaQuery'
import React from 'react'
import styled from 'styled-components'

const SectionDivider = styled.img`
  position: relative;
  width: 250%;
  margin-top: ${({ marginTop }) => (marginTop ? `${marginTop / 1.5}px` : '-35px')};
  @media ${minWidthQueries.md} {
    width: 100%;
    margin-top: ${({ marginTop }) => (marginTop ? `${marginTop / 2}px` : '-25px')};
  }
  @media ${minWidthQueries.lg} {
    margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px` : '-55px')};
  }
`

const Divider = ({ src, marginTop }) => {
  return <SectionDivider marginTop={marginTop} src={src} />
}

export default Divider
